import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { useState } from "react";
import { btnOne, title, btnOneNoWidth } from "../utils/style";
import edit from '../assets/icons/edit.png'
import UpdateGlobalConfig from "../modals/UpdateGlobalConfig";
import formatNumberToUs from "../custom_functions/formatNumberToUs";
function GlobalConfig() {
    const [showForm, setShowForm] = useState(false)
    const [reloadTable, setReloadTable] = useState(false)
    const [data, setData] = useState({})

    const options = [
        {
            header: 'Name',
            key: 'name',
            render: (str) => {
                switch (true) {
                    case str.name === "defaultTax":
                        return "Default Tax % (B2C & B2B)";
                    case str.name === "maxDiscount":
                        return "Max Discount % (B2C)";
                    case str.name === "maxEstimateImageSize":
                        return `Estimate Image Size (Max 10 MB)`;
                    case str.name === "estimateExpirationDay":
                        return `Estimate Expiration Day (Max 30 days)`;
                    case str.name === "importRowsLimit":
                        return `Import Rows Limit (Max 500 rows)`;
                    default:
                        return str.name === "defaultTax" ? "Default Tax % " : str.name === "maxDiscount" ? "Max Discount % (B2C)" : str.name.replace(/([A-Z])/g, ' $1').replace(/^./, c => c.toUpperCase()).trim();
                }
            },
            filterKey: 'name',
            width: "50%"
        },
        {
            header: 'Value',
            key: 'value',
            render: (data) => {
                switch (true) {
                    case data.name === "defaultTechnicianCost":
                        return `$${formatNumberToUs(data.value)}`;

                    case data.name.includes("Discount"):
                        return `${data.value}%`;

                    default:
                        return data.value;
                }
            },
            width: "30%"
        },
        {
            header: 'Action',
            render: (data) => {
                return (
                    <div className="flex space-x-2">
                        <button
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={(e) => { e.stopPropagation(); handleEdit(data) }}
                        >
                            <img alt={"edit"} src={edit} height={15} width={15} />
                        </button>
                    </div>
                )
            },
            width: "20%",
        },

    ]

    const excludeFilter = ['Name', 'Value', 'Action']

    const handleEdit = (data) => {
        setData(data);
        setShowForm(true);
    }

    return (
        <div className="overflow-y-auto">
            {
                showForm && <UpdateGlobalConfig setShowForm={setShowForm} reload={setReloadTable} data={data} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Global Configuration</div>
            </div>
            <Table
                options={options}
                url={url + '/global_config'}
                pagination={false}
                reloadTable={reloadTable}
                noButton={true}
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default GlobalConfig;